import moment from 'moment';

const isDateFuture = date => {
  let today_date = moment ();
  let future_date = moment.utc (date).local ();
  /* future - today > 0  || today - future < 0 */
  return future_date.diff (today_date) > 0;
};

const getInPercent = (num1 = 0, num2) => {
  if (!num2) return 0;
  return num1 * 100 / num2;
};


export {
  isDateFuture,
  getInPercent
};
